import React, { ChangeEvent } from 'react';

import { Input } from '@eika/input';

import TranslationsConfigType from '../../../../translations/translationType';

import './AccountNameField.scss';

interface Props {
    accountName: string;
    handleAccountNameChange: (event: ChangeEvent<HTMLInputElement>) => void;
    translated: TranslationsConfigType;
    validationMessage?: string;
    onFocus?: () => void;
    onBlur?: () => void;
    isNettbank?: boolean;
}

const AccountNameField: React.FC<Props> = ({
    accountName,
    handleAccountNameChange,
    translated,
    validationMessage,
    onFocus,
    onBlur,
    isNettbank = false,
}) => (
    <div className="account-name-field__container">
        <label htmlFor="account-name-field-input" className="account-name-field__label">
            {translated.name}
        </label>
        <Input
            autoFocus={isNettbank}
            placeholder={translated.paymentFromAccountName}
            value={accountName}
            onChange={handleAccountNameChange}
            maxLength={35}
            error={validationMessage}
            onFocus={onFocus}
            onBlur={onBlur}
            id="account-name-field-input"
        />
    </div>
);

export default AccountNameField;
